



















































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { InterpreterLanguage, Language } from '@/types/entity';
import { ApiRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import { ModelSelect } from 'vue-search-select';
import { ApiResponse, UploadFileResponse } from '@/types/response';

@Component({
    mixins: [validationMixin],
    components: {
        ModelSelect,
    },
    data() {
        return {
            name: '',
            options: [],
            language: {
                languageName: '',
                languageId: '',
                certificates: [
                    {
                        certificateId: '',
                        name: '',
                    },
                ],
            },
            certificate: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations: {
        language: {
            required,
            languageId: {
                required,
            },
        },
        certificate: {
            required,
        },
    },
})
export default class AddModal extends Vue {
    private show = true;
    private languages: Language[] = [];

    public mounted() {
        this.show = true;
        this.$data.options = [];
        this.getLanguages();
        this.getPartnerProfile();
    }
    private async getLanguages() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_LANGUAGES}`,
            loaderEvent: {
                show: true,
            },
        };
        const apiResponse = await iHttpService.get<Language[]>(apiRequest);
        if (apiResponse.success && apiResponse.data) {
            this.languages = apiResponse.data;
            apiResponse.data.forEach((element) => {
                const option = {
                    value: element.id,
                    text: element.name,
                };
                this.$data.options.push(option);
            });
        } else {
            CommonUtils.showError(apiResponse);
        }
    }


    private async setCertificate($event: any, index: number) {
        const filename: string = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            this.$data.certificate.file = $event.target.files[0];
            this.$data.certificate.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = `file-input${index}`;
            const element = this.$refs[inputName] as any;
            element[0].reset();
        }
    }

    private async uploadFile(file: FormData, baseUrl: string): Promise<ApiResponse<UploadFileResponse>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: file,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<UploadFileResponse>(apiRequest);
        if (response.success && response.data) {
            return response;
        } else {
            CommonUtils.showError(response);
            throw new Error(JSON.stringify(response));
        }
    }

    private async getPartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            const partnerProfile = response.data;
            if (partnerProfile.interpreterProfile && partnerProfile.interpreterProfile.languages) {
                partnerProfile.interpreterProfile.languages.forEach((element) => {
                    const index = this.languages.findIndex((language) => {
                        return language.id === element.languageId;
                    });
                    if (index >= 0) {
                        this.languages.splice(index, 1);
                    }
                });
            }
        }
    }

    private async addInterpreterLanguage() {
        if (this.$data.certificate.filename !== '') {
            const formData = new FormData();
            formData.append('file', this.$data.certificate.file);
            const uploadResponse = await this.uploadFile(formData, this.$store.state.serverUrl);
            if (uploadResponse.data) {
                this.$data.language.certificates[0].certificateId = uploadResponse.data.fileName;
                this.$data.language.certificates[0].name = this.$data.certificate.filename;
            }
        }
        const iHttpService = ObjectFactory.getHttpService();
        const interpreterLanguage: InterpreterLanguage = {
            languageId: this.$data.language.languageId,
            languageName: this.$data.language.languageName,
            certificates: this.$data.language.certificates,
        };
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const response = await iHttpService.post({
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/${userId}/languages`,
            data: interpreterLanguage,
            method: 'POST',
            loaderEvent: {
                show: true,
            },
        });
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Language added successfully`,
                title: 'Message',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }

    }
    private close() {
        this.$emit('close');
    }
}
